module.exports = __webpack_public_path__ + "img/HINDU DIWALI GREEN.870c32a.svg";